import html2canvas from "html2canvas";
import { toast } from "sonner";

function isInAppBrowser() {
  return /Instagram|FBAN|FBAV|FB_IAB|FBAN\/|Line\/|TikTok|Musical_ly|Twitter|WhatsApp|Telegram/i.test(navigator.userAgent || "");
}

function showSaveOverlay(url) {
  const overlay = document.createElement("div");
  overlay.setAttribute("data-testid", "inapp-save-overlay");
  overlay.style.cssText = "position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.94);display:flex;align-items:center;justify-content:center;padding:16px;overflow:auto;";
  const box = document.createElement("div");
  box.style.cssText = "max-width:420px;width:100%;text-align:center;";
  const img = document.createElement("img");
  img.src = url;
  img.setAttribute("data-testid", "inapp-save-image");
  img.style.cssText = "width:100%;max-height:62vh;object-fit:contain;border:1px solid #FF3B30;background:#0A0A0A;";
  const text = document.createElement("div");
  text.style.cssText = "color:#fff;font-size:13px;margin-top:14px;line-height:1.6;";
  text.innerText = "Browser Instagram tidak mendukung unduhan otomatis. TEKAN LAMA gambar di atas lalu pilih Simpan Gambar, atau screenshot layar ini. Untuk pengalaman terbaik, SALIN LINK halaman ini lalu buka di Chrome.";
  const copyBtn = document.createElement("button");
  copyBtn.innerText = "SALIN LINK";
  copyBtn.setAttribute("data-testid", "inapp-save-copy");
  copyBtn.style.cssText = "background:#0A0A0A;color:#FF3B30;border:1px solid #FF3B30;padding:10px 22px;font-size:12px;letter-spacing:2px;cursor:pointer;";
  copyBtn.onclick = async () => {
    const link = window.location.href;
    try {
      await navigator.clipboard.writeText(link);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = link;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    copyBtn.innerText = "LINK TERSALIN";
  };
  const btn = document.createElement("button");
  btn.innerText = "TUTUP";
  btn.setAttribute("data-testid", "inapp-save-close");
  btn.style.cssText = "background:#FF3B30;color:#fff;border:none;padding:10px 28px;font-size:12px;letter-spacing:2px;cursor:pointer;";
  btn.onclick = () => { overlay.remove(); URL.revokeObjectURL(url); };
  const btnRow = document.createElement("div");
  btnRow.style.cssText = "margin-top:14px;display:flex;gap:10px;justify-content:center;";
  btnRow.appendChild(copyBtn);
  btnRow.appendChild(btn);
  box.appendChild(img);
  box.appendChild(text);
  box.appendChild(btnRow);
  overlay.appendChild(box);
  document.body.appendChild(overlay);
}

export async function downloadElementAsPng(elementId, filename, targetWidth = 1800) {
  const el = document.getElementById(elementId);
  if (!el) {
    toast.error("Elemen tidak ditemukan");
    return;
  }
  // Rasterize an untransformed off-screen clone at natural width:
  // html2canvas mis-measures text inside CSS-transformed ancestors (scale-90/75/50 wrappers).
  const clone = el.cloneNode(true);
  clone.removeAttribute("id");
  clone.style.transform = "none";
  const host = document.createElement("div");
  host.style.cssText = "position:fixed;left:-10000px;top:0;z-index:-1;";
  host.appendChild(clone);
  document.body.appendChild(host);
  try {
    const width = clone.getBoundingClientRect().width || clone.offsetWidth;
    const scale = Math.min(8, Math.max(2, targetWidth / width));
    const canvas = await html2canvas(clone, {
      backgroundColor: "#0A0A0A",
      scale,
      useCORS: true,
      allowTaint: true,
      width,
      windowWidth: width + 40,
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        toast.error("Gagal membuat gambar");
        return;
      }
      const url = URL.createObjectURL(blob);
      if (isInAppBrowser()) {
        showSaveOverlay(url);
      } else {
        const link = document.createElement("a");
        link.download = filename;
        link.href = url;
        link.click();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      }
    }, "image/png");
  } catch (e) {
    toast.error("Gagal mengunduh: " + e.message);
  } finally {
    host.remove();
  }
}
